import { createFileRoute, Outlet } from '@tanstack/react-router'

import { BackofficePage } from '../components/templates/backoffice-page.tsx'

export const Route = createFileRoute('/bo')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <BackofficePage>
      <Outlet />
    </BackofficePage>
  )
}
